import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSavedSearch } from "common/apis/saved-search";
import { Storage } from "common/storage";

export function usePostDeleteSavedSearch() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      id,
    }: {
      id: number;
    }) => {
      return deleteSavedSearch(
        id,
        accessToken || ""
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["savedSearches"],
        exact: false,
      });
    },
  });

  return {
    deleteSavedSearch: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
